// Centralized error messages for authentication and astrology services

export const ERROR_MESSAGES = {
  AUTH: {
    CONFIG_NOT_FOUND: 'Authentication is not properly configured. Please contact support.',
    EMAIL_IN_USE: 'This email is already registered',
    INVALID_EMAIL: 'Invalid email address',
    WEAK_PASSWORD: 'Password is too weak',
    OPERATION_NOT_ALLOWED: 'Email/password accounts are not enabled. Please contact support.',
    USER_NOT_FOUND: 'Invalid email or password',
    WRONG_PASSWORD: 'Invalid email or password',
    TOO_MANY_REQUESTS: 'Too many failed attempts. Please try again later',
    DEFAULT: 'An error occurred during authentication',
    LOGOUT: 'An error occurred during logout',
    GOOGLE: 'An error occurred during Google sign-in',
  },
  ASTROLOGY: {
    OPENAI_KEY: 'OpenAI API key is not configured. Please check your .env file.',
    API: 'Failed to get astrology insight',
    HOROSCOPE: 'Failed to get daily horoscope',
    BIRTH_CHART: 'Failed to get birth chart summary',
    UNEXPECTED_API: 'Unexpected API response',
  },
}; 
